import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/AboutPageComponents/ScStGrievanceComponents/ScStGrievance/ScStGrievance.tsx");
